//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/Features.js";
let d=[[[1,"AdoptBodySelect",0,"ScCollector",0],[0,"FaceCharacteristics",0,"Features.ShipDesign.GeneralArrangement.FaceCharacteristicsBuilder",0],[1,"PanelSketchSection",0,"Section",0],[1,"RoomBodySelect",0,"ScCollector",0],[1,"Thickness",0,"Expression",0],[0,"ThicknessDirection",1,0],[0,"ThicknessType",1,0],[0,"Tolerance",1,0],[0,"Type",1,0]],[],[]];
SPLM.Features.ShipDesign.RoomPanelBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.RoomPanelBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.RoomPanelBuilder.Types = Object.freeze({
    "Create" : "Create", "Adopt" : "Adopt"});

SPLM.Features.ShipDesign.RoomPanelBuilder.JaRoomPanelThicknessTypes = Object.freeze({
    "Symmetric" : "Symmetric", "SingleSided" : "SingleSided"});

export default SPLM;